export default "__VITE_ASSET__O$mGKDmR__"